import { render, staticRenderFns } from "./EditProfessionalDataForm.vue?vue&type=template&id=9d94ceea"
import script from "./EditProfessionalDataForm.vue?vue&type=script&lang=js"
export * from "./EditProfessionalDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports